<template>
  <v-card dark color="primary lighten-2">
    <v-card-title>
      <v-btn v-if="hasChanged" fab small color="white" @click="SaveService">
        <v-icon light color="primary">mdi-content-save</v-icon>
      </v-btn>
      <v-btn fab dark small color="error" @click="DeleteService">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <b>
          <v-text-field
            label="Name"
            required
            v-model="service.serviceName"
            @input="$v.service.serviceName.$touch()"
            :error-messages="ServiceNameErrors"
            maxlength="100"
            counter
          ></v-text-field>
        </b>
      </v-flex>
      <v-flex xs12>
        <v-menu
          ref="menu"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="service.duration"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="service.duration"
              label="Duration hh:mm"
              append-icon="mdi-clock-outline"
              :error-messages="DurationErrors"
              @input="$v.service.duration.$touch()"
              required
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu2"
            v-model="service.duration"
            @change="$refs.menu.save(service.duration)"
            @input="$v.service.duration.$touch()"
            min="00:05"
            max="10:00"
            format="24hr"
            :allowed-hours="allowedHours"
            :allowed-minutes="allowedMinutes"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          type="number"
          label="Price"
          v-model="service.price"
          @input="$v.service.price.$touch()"
        ></v-text-field>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: ["service"],
  data: () => ({
    
      menu2: false,
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 100 || "Max 100 characters"
      }
    
  }),
  methods: {
    DeleteService() {
      this.$emit("delete", this.service);
    },
    SaveService() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let companyID = this.$store.getters.user.details.companyId;

      if (this.Invalid() || !companyID) {
        this.showError("Could not save service!");
        return;
      }

      this.$emit("save", this.service);
      this.$v.$reset();
    },
    Invalid() {
        
      return this.$v.$invalid;
    },
    allowedHours: v => v <= 8,
    allowedMinutes: v => v % 5 === 0,
    allowedStep: m => m % 5 === 0
  },
  validations: {
    service: {
      serviceName: { required },
      duration: { required },
      price: {}
    }
  },
  computed: {
    ServiceNameErrors() {
      const errors = [];
      if (!this.$v.service.serviceName.$dirty) return errors;
      !this.$v.service.serviceName.required && errors.push("Name is required");
      return errors;
    },
    DurationErrors() {
      const errors = [];
      if (!this.$v.service.duration.$dirty) return errors;
      !this.$v.service.duration.required && errors.push("Duration is required");
      return errors;
    },
    
    
    hasChanged() {
      return this.$v.service.$anyDirty;
      },
      
  },
  watch: {
    service: function() {
      this.$v.$reset();
    }
  }
};
</script>

<style>
</style>